export const LineaDetalle = {
    NumeroLinea: 0,
    Codigo: '',
    CodigoComercial: {
      Tipo: '',
      Codigo: ''
    },
    Cantidad: 1,
    UnidadMedida: '',
    UnidadMedidaComercial: '',
    Detalle: '',
    PrecioUnitario: 0,
    MontoTotal: 0,
    Descuentos: null,
    SubTotal: 0,
    BaseImponible: 0,
    Impuestos: null,
    ImpuestoNeto: 0,
    MontoTotalLinea: 0
  };